<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolID" style="font-size:smaller;"
                    [(ngModel)]="SchoolID"
                    (ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
                </select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="loading == true" [TableTypeID]="2"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onEditSchoolDay()">Edit School Day</button>

		<button [disabled]="loading == true || MoveUpDisabled == true" class="btn btn-primary" style="margin-left: 5px" (click)="onMoveUp()">Move Up</button>
		<button [disabled]="loading == true || MoveDownDisabled == true" class="btn btn-primary" style="margin-left: 5px" (click)="onMoveDown()">
			Move Down
		</button>

		<!--CAASS 9.5 Calls SP that does nothing-->
		<!-- <button class="btn btn-primary" style="margin-left:5px;" (click)="onCheckValidity()">TEST School Day Validity</button> -->
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSchoolDay"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSchoolDay"
		dataKey="DayID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--DayDesc-->
				<th>
					<p-columnFilter type="text" field="DayDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--DayCD-->
				<th>
					<p-columnFilter type="text" field="DayCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Default_BellScheduleDesc-->
				<th>
					<p-columnFilter field="Default_BellScheduleDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefault_BellScheduleDesc
								[ngModel]="value"
								[options]="lstDefault_BellScheduleDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolName
								[ngModel]="value"
								[options]="lstSchoolName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ZOrder-->
				<th></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="DayDesc">Description<p-sortIcon field="DayDesc"></p-sortIcon></th>
				<th pSortableColumn="DayCD">Code<p-sortIcon field="DayCD"></p-sortIcon></th>
				<th pSortableColumn="Default_BellScheduleDesc">Default Bell Schedule<p-sortIcon field="Default_BellScheduleDesc"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">Available To<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="ZOrder">Order<p-sortIcon field="ZOrder"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-SchoolDay>
			<tr [pSelectableRow]="SchoolDay" (dblclick)="onRowDblClick(SchoolDay)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ SchoolDay[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
